<template>
  <div>
    <Table :data="reportData" :columns="columns">

    </Table>
    <Modal
      v-model="declareReportVisible"
      :title="declareReportTitle"
      width="98%"
      height="95%"
      class="declare-report"
      :transfer="flowPosition==='detail'"
    >
      <iframe
        :src="declareReportUrl"
        style="width:100%;height:700px;border:0"
      ></iframe>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import requestUrls from '@/lib/requestUrls'
import { formatDate } from '@/lib/tool'

export default {
  name: 'commissionGrantRxtra',
  props: {
    flowDetail: {
      type: Object
    },
    flowPosition: {
      type: String,
      default: 'detail'
    }
  },
  data() {
    return {
      declareReportTitle: '',
      declareReportUrl: '',
      declareReportVisible: false,
      columns: [
        {
          title: '报表类型',
          width: 300,
          key: 'reportType'
        },
        {
          title: '报表数据',
          render: (h, params) => {
            let reportArr = []
            params.row.report.forEach(report => {
              reportArr.push(h('a', {
                domProps: {
                  href: 'javascript:void(0)'
                },
                style: {
                  marginRight: '20px',
                  display: 'inline-block'
                },
                on: {
                  click: () => {
                    this.viewReport(report.key)
                  }
                }
              }, report.title))
            })
            return h('div', reportArr)
          }
        }
      ],
      reportData: [
        {
          reportType: '（线上）当月奖金分配申请表',
          report: [
            {
              title: '(线上)当月奖金分配申请表',
              key: 'onlineAllotApply'
            },
          ]
        },
        {
          reportType: '当月奖金分配申请表',
          report: [
            {
              title: '当月奖金分配申请表',
              key: 'allotApply'
            },
          ]
        },
        {
          reportType: '当月数据一览(2021年回款)',
          report: [
            {
              title: '分公司当月可分配奖金总额表',
              key: 'distribute2021'
            },
          ]
        },
        {
          reportType: '当月数据一览(2020年回款)',
          report: [
            {
              title: '分公司当月可分配奖金总额表',
              key: 'distribute2020'
            },
          ]
        },
        {
          reportType: '当月数据一览(2019年回款)',
          report: [
            {
              title: '分公司当月可分配奖金总额表',
              key: 'distribute2019'
            },
          ]
        },
      ]
    }
  },
  methods: {
    viewReport(type) {
      if (this.flowDetail.area === '' || this.flowDetail.company === '' || this.flowDetail.time === '') {
        this.$Message.info('请确认时间、地区及分子公司')
        return
      }

      // 报表特殊时间要求传入
      let baseTime = formatDate(this.flowDetail.time)
      let time = baseTime.split(' ')[0].substr(0, 8) + '01'
      let startTime = baseTime.split(' ')[0].substr(0, 4) + '-01-01'
      let endTime = baseTime.split(' ')[0].substr(0, 4) + '-12-01'

      if (type === 'rule') {
        this.declareReportTitle = '分公司奖金规则申报表'
        this.declareReportUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B8d22%5D%5B52a1%5D%5B63d0%5D%5B6210%5D%2F%5B63d0%5D%5B6210%5D%5B89c4%5D%5B5219%5D%2F%5B5206%5D%5B516c%5D%5B53f8%5D%5B5956%5D%5B91d1%5D%5B53d1%5D%5B653e%5D%5B89c4%5D%5B5219%5D%5B7533%5D%5B62a5%5D%5B8868%5D.cpt&op=write`
      }
      if (type === 'allot') {
        this.declareReportTitle = '奖金确认表'
        this.declareReportUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B8d22%5D%5B52a1%5D%5B63d0%5D%5B6210%5D%2F%5B5206%5D%5B516c%5D%5B53f8%5D%5B63d0%5D%5B6210%5D%5B6c47%5D%5B603b%5D%2F%5B5956%5D%5B91d1%5D%5B786e%5D%5B8ba4%5D%5B8868%5D.cpt&op=write&branch=${this.flowDetail.area}&childcompany=${this.flowDetail.company}&collectiondate=${time}`
      }
      if (type === 'bussinessDetail') {
        this.declareReportTitle = '业务奖金明细表'
        this.declareReportUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B8d22%5D%5B52a1%5D%5B63d0%5D%5B6210%5D%2F%5B5206%5D%5B516c%5D%5B53f8%5D%5B63d0%5D%5B6210%5D%5B6c47%5D%5B603b%5D%2F%5B4e1a%5D%5B52a1%5D%5B5956%5D%5B91d1%5D%5B660e%5D%5B7ec6%5D%5B8868%5D%5B4e00%5D.cpt&op=write&branch=${this.flowDetail.area}&childcompany=${this.flowDetail.company}&collectiondate=${time}`
      }
      if (type === 'projectDetail') {
        this.declareReportTitle = '项目奖金明细表'
        this.declareReportUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B8d22%5D%5B52a1%5D%5B63d0%5D%5B6210%5D%2F%5B5206%5D%5B516c%5D%5B53f8%5D%5B63d0%5D%5B6210%5D%5B6c47%5D%5B603b%5D%2F%5B9879%5D%5B76ee%5D%5B5956%5D%5B91d1%5D%5B660e%5D%5B7ec6%5D%5B8868%5D%5B4e8c%5D.cpt&op=write&branch=${this.flowDetail.area}&childcompany=${this.flowDetail.company}&collectiondate=${time}`
      }
      if (type === 'distribute2019') {
        this.declareReportTitle = '分公司当月可分配奖金总额表'
        this.declareReportUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B8d22%5D%5B52a1%5D%5B63d0%5D%5B6210%5D%2F%5B5206%5D%5B516c%5D%5B53f8%5D%5B63d0%5D%5B6210%5D%5B6c47%5D%5B603b%5D%2F%5B5206%5D%5B516c%5D%5B53f8%5D%5B5f53%5D%5B6708%5D%5B53ef%5D%5B5206%5D%5B914d%5D%5B5956%5D%5B91d1%5D%5B603b%5D%5B989d%5D%5B8868%5D%5B4e09%5D.cpt&op=write&branch=${this.flowDetail.area}&childcompany=${this.flowDetail.company}&collectiondate=${time}`
      }
      if (type === 'distribute2020') {
        this.declareReportTitle = '分公司当月可分配奖金总额表'
        this.declareReportUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian/财务提成2.0/分公司提成汇总/分公司当月可分配奖金总额表三.cpt&op=write&branch=${this.flowDetail.area}&childcompany=${this.flowDetail.company}&collectiondate=${time}`
      }
      if (type === 'distribute2021') {
        this.declareReportTitle = '分公司当月可分配奖金总额表'
        this.declareReportUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian/财务提成3.0/省内分公司/分公司提成汇总/分公司当月可分配奖金总额表三.cpt&op=write&branch=${this.flowDetail.area}&childcompany=${this.flowDetail.company}&collectiondate=${time}`
      }
      if (type === 'allotApply') {
        this.declareReportTitle = '当月奖金分配申请表'
        this.declareReportUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian/财务提成3.0/省内分公司/分公司提成汇总/公司当月奖金分配申请表四.cpt&op=write&branch=${this.flowDetail.area}&childcompany=${this.flowDetail.company}&collectiondate=${time}`
      }
      if (type === 'onlineAllotApply') {
        this.declareReportTitle = '（线上）当月奖金分配申请表'
        this.declareReportUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian/财务提成3.0/省内分公司/分公司提成汇总/公司当月奖金分配申请表四（线上）.cpt&op=write&branch=${this.flowDetail.area}&childcompany=${this.flowDetail.company}&collectiondate=${time}`
      }
      this.declareReportVisible = true
    },
  }
}
</script>

<style lang="less">
.declare-report {
  .ivu-modal {
    top: 20px;
    height: 95%;
    .ivu-modal-content {
      height: 100%;
    }
    .ivu-modal-body {
      height: 90%;
      overflow: auto;
    }
    .ivu-icon-ios-close-empty {
      font-size: 45px;
      color: #000;
    }
  }
}
</style>
